<template>
  <div class="home">
    <Header />
    <Slider :image="require('../assets/slider/hatartalan_microsite_main_v7.png')" >
      <h2>2020 a nemzeti összetartozás éve</h2>
      <hr />
      <p>A Skanzen programjainak  központi eleme a magyar nemzet, a magyar kultúra
        határtalan- sága. Ezt mutatjuk meg a virtuális térben, határok nélkül.</p>
    </Slider>
    <div class="home-content">
      <div class="row no-gutters">
          <HomeCard :image="require('@/assets/images/Layer_221.png')"
                    style="margin-top: -17px;">
            <a href="http://amml.skanzen.hu/" target="_blank">
              <h2>Amikor minden más lett... Élet a
                nagy háború alatt és után | Virtu-
                ális kiállítás</h2>
            </a>
            <p>Virtuális kiállításunk segítségével megismerheti, hogy miben lettek mások
              a mindennapok a vidéki Magyarországon az első világháború alatt és után.</p>
          </HomeCard>
          <HomeCard :image="require('@/assets/images/maszk.png')" style="margin-top: -8px;">
            <router-link to="/virtualis-kiallitasok/mutasd-a-maszkod">
              <h2>Mutasd a maszkod! | Virtuális
                kiállítás</h2></router-link>
            <p>2020 rendkívüli év. A  COVID-19 vírus átalakította mindennapjainkat.
              A Skanzen közösségi
              felhívásban gyűjti azokat a történeteket, amelyek a maszkviseléssel kapcsolatosak.
              Megmutatjuk őket.</p>
          </HomeCard>
          <HomeCard :image="require('@/assets/images/Layer_15.png')"
                    style="margin-top: -10px;">
            <router-link :to="{path: '/virtualis-kiallitasok/trianoni-arvak'}">
              <h2>Trianon árvái | Virtuális kiállítás</h2></router-link>
            <p>A trianoni béke következtében a hivatalos statisztikák szerint 350 ezer,
              utólagos becslések szerint pedig mintegy 425 ezer ember hagyta el otthonát.
              A menekültek egy része évekig élt szükségszállásokon vagy pályaudvarokon,
              vasúti vagonokban.</p>
          </HomeCard>
      </div>
      <div class="row no-gutters">
          <HomeCard :image="require('@/assets/images/a_nagy_haboru.png')">
            <a href="https://nagyhaboru.skanzen.hu/" target="_blank">
              <h2>A nagy háború emlékei –
              adatbázis</h2>
            </a>
            <p>A Szabadtéri Néprajzi Múzeum első világháborús tematikus adatbázisa,
              amely a hazai és határon túli közgyűjteményekben és
              magánszemélyeknél elérhető kulturális javakat gyűjti össze. </p>
          </HomeCard>
          <HomeCard :image="require('@/assets/images/hosi_emlekmuvek.png')"
                    style="margin-top: -12px;">
            <a href="http://emlekmuvek.skanzen.hu/" target="_blank">
              <h2>Hősi emlékművek -
              Interaktív térkép</h2>
            </a>
            <p>Térképünk a több ezer első világháborús hősi emlék helyét és
              fotóját mutatja meg a Kárpát-medence magyarlakta területein.</p>
          </HomeCard>
          <HomeCard :image="require('@/assets/images/hatartortenetek.png')">
            <router-link :to="{path: '/hatartortenetek'}">
              <h2>
                Határtörténetek
              </h2>
            </router-link>
            <p>Az elmúlt száz évben a határon nemcsak hivatalos kereskedelem folyt, de rengeteg
              árut csempésztek. Ismerje meg 100 év történeteit! Önnek van ilyen története?</p>
          </HomeCard>
      </div>
      <div class="row no-gutters">
		<HomeCard :image="require('@/assets/images/Layer_224.png')">
          <a href="https://muzeumpedagogiaonline.skanzen.hu/" target="_blank">
          <h2>Múzeumpedagógia</h2>
          </a>
          <p>Online múzeumpedagógiai projekt az "Amikor minden más lett -
            Élet a nagy háború alatt és után" című virtuális
            kiállításunkhoz kapcsolódva: „Hogyan segíthetek?”</p>
        </HomeCard>		
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import Slider from '@/components/Slider.vue';
import Footer from '@/components/Footer.vue';
import HomeCard from '@/components/HomeCard.vue';

export default {
  name: 'Home',
  components: {
    Slider,
    Header,
    Footer,
    HomeCard,
  },
};
</script>
